const API_BASE = process.env.REACT_APP_API_BASE_URL || "/api";

function getAuthValue(key) {
  return localStorage.getItem(key) ?? sessionStorage.getItem(key);
}

function esSesionPersistible() {
  const token = getAuthValue("token");
  const esInvitado = getAuthValue("guest") === "true";
  const esAnonimo = getAuthValue("anonimo") === "true";
  return !!token && !esInvitado && !esAnonimo;
}

async function registrarRecienteEnBackend(recursoId) {
  if (!esSesionPersistible() || !recursoId) return;

  const token = getAuthValue("token");
  try {
    await fetch(`${API_BASE}/mi-biblioteca/recientes/${recursoId}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (error) {
    console.warn("No se pudo registrar reciente en backend:", error);
  }
}

export const registrarRecursoReciente = (recurso) => {
  const existentes = JSON.parse(localStorage.getItem("recientes")) || [];
  const filtrados = existentes.filter((r) => r.id !== recurso.id);
  const actualizados = [recurso, ...filtrados].slice(0, 20);
  localStorage.setItem("recientes", JSON.stringify(actualizados));
  window.dispatchEvent(new Event("recientes-actualizados"));

  registrarRecienteEnBackend(recurso?.id);
};
